import React  from "react"
import { Badge } from "reactstrap"

//Nearest Events
import bWFuYWdlTmVhcmVzdEV2ZW from "store/bWFuYWdlTmVhcmVzdEV2ZW"
import bXlOZWFyZXN0RXZlbnRz from "store/bXlOZWFyZXN0RXZlbnRz"
import ZXZlbnRDYW5jZWw from "store/ZXZlbnRDYW5jZWw"

//Operations

import cHJlUGVuZGluZ1NoYXJl from "store/cHJlUGVuZGluZ1NoYXJl"
import cHJlU2hhcmVkQ2xpZW from "store/cHJlU2hhcmVkQ2xpZW"
import cG9zdFBlbmRpbm from "store/cG9zdFBlbmRpbm"
import cG9zdFNoYXJlZF from "store/cG9zdFNoYXJlZF"
import bXlDbGllbnRRY0Nvb from "store/bXlDbGllbnRRY0Nvb"
import bXlDbGllbnRTaGFy from "store/bXlDbGllbnRTaGFy"

import Y3JtUHJpbnRQZW from "store/Y3JtUHJpbnRQZW"
import Y3JtUHJpbnREa from "store/Y3JtUHJpbnREa"
import Y3JtUHJpbnREaXNwY from "store/Y3JtUHJpbnREaXNwY"
import Y3JtUHJpbnREZWxp from "store/Y3JtUHJpbnREZWxp"

import cHJpbnRQbERpc3 from "store/cHJpbnRQbERpc3"
import cHJpbnRQbERpc3Bhd from "store/cHJpbnRQbERpc3Bhd"
import cHJpbnRQbFVuQXN from "store/cHJpbnRQbFVuQXN"
import cHJpbnRQbFByaW50U from "store/cHJpbnRQbFByaW50U"

//Tickets

import aW5wcm9ncmVzc1NlbnQ from "store/aW5wcm9ncmVzc1NlbnQ"
import aW5wcm9ncmVzc1JlY2VpdmVk from "store/aW5wcm9ncmVzc1JlY2VpdmVk"
import aW5wcm9ncmVzc0Nj from "store/aW5wcm9ncmVzc0Nj"
import Y29tcGxldGVkU2VudA from "store/Y29tcGxldGVkU2VudA"
import Y29tcGxldGVkUmVjZWl2ZWQ from "store/Y29tcGxldGVkUmVjZWl2ZWQ"
import Y29tcGxldGVkQ2M from "store/Y29tcGxldGVkQ2M"
import dGlja2V0Q2xvc2Vk from "store/dGlja2V0Q2xvc2Vk"

//Approvals

import cWNSZWNoZWNrTGlzdA from "store/cWNSZWNoZWNrTGlzdA"
import ZnJlZWxhbmNlclFj from "store/ZnJlZWxhbmNlclFj"
import ZnJlZWxhbmNlckF1ZGl0UWM from "store/ZnJlZWxhbmNlckF1ZGl0UWM"

import ZW1wbG95ZWVSZXBvcnQ from "store/ZW1wbG95ZWVSZXBvcnQ"

//EC Shooter
import c2hvb3RlclJlcG9ydA from "store/c2hvb3RlclJlcG9ydA"
import c2hvb3RlckF2YWlsYWJpbGl0eQ from "store/c2hvb3RlckF2YWlsYWJpbGl0eQ"
import bWFuYWdlUHJpbnRWZW5k from "store/bWFuYWdlUHJpbnRWZW5k"
import cGFzc3dvcmRTZXR1cA from "store/cGFzc3dvcmRTZXR1cA"

//BDM
import YmRtU291cmNlU3RhdHVz from "store/YmRtU291cmNlU3RhdHVz"
import bGVhZFNvdXJjZVN0YXR1cw from "store/bGVhZFNvdXJjZVN0YXR1cw"
import b3BlcmF0aW9uc0 from "store/b3BlcmF0aW9uc0"
import YmRtQWNjb3 from "store/YmRtQWNjb3"
import YmRtUGFzc3 from "store/YmRtUGFzc3"
import c3RkQXJjaGl from "store/c3RkQXJjaGl"
import bXlOZWFyRnV0d from "store/bXlOZWFyRnV0d"

import Z2V0UGhvdG9 from "store/Z2V0UGhvdG9"
import c2VydmljZVF1YW5 from "store/c2VydmljZVF1YW5"
import ZnJlZWxhbmNlclF1 from "store/ZnJlZWxhbmNlclF1"
import ZnJlZWxhbmNlclF0eUxpc3Q from "store/ZnJlZWxhbmNlclF0eUxpc3Q"
import ZnJlZWxhbmNlclByb2plY3Rpb25zTGlzdA from "store/ZnJlZWxhbmNlclByb2plY3Rpb25zTGlzdA"

import ZXZlbnRDbGllbn from "store/ZXZlbnRDbGllbn"
import b3BlcmF0aW9uc from "store/b3BlcmF0aW9uc"
import cHJvZHVjdFN0 from "store/cHJvZHVjdFN0"
import Y2xpZW50Vmlza from "store/Y2xpZW50Vmlza"
import cHJvZHVjdFN0YXR1c0 from "store/cHJvZHVjdFN0YXR1c0"
import ZXdXaXNlRG from "store/ZXdXaXNlRG"
import cG9zdENsaW from "store/cG9zdENsaW"
import Y3JtV2lzZVBlbmR from "store/Y3JtV2lzZVBlbmR"
import bW9udGhXaX from "store/bW9udGhXaX"
import cG9zdENybU9uSG from "store/cG9zdENybU9uSG"
import bW9udGhXaXNlUGVu from "store/bW9udGhXaXNlUGVu"
import bXlDbGllbnRPb from "store/bXlDbGllbnRPb"
import bXlXb3Jrc09uSG9s from "store/bXlXb3Jrc09uSG9s"
import cG9zdE5vdEFw from "store/cG9zdE5vdEFw"
import cG9zdFFjUmVja from "store/cG9zdFFjUmVja"
import bXlXb3Jrc1Fj from "store/bXlXb3Jrc1Fj"
import bXlDbGllbnRRY from "store/bXlDbGllbnRRY"
import Y3JtV2lzZVByb from "store/Y3JtV2lzZVByb"
import ZXdXaXNlUH from "store/ZXdXaXNlUH"
import ZXZlbnRNb250 from "store/ZXZlbnRNb250"
import Y29weURhdGE from "store/Y29weURhdGE"
import c2VydmljZV9sZX from "store/c2VydmljZV9sZX"
import ZGF0YUNvc from "store/ZGF0YUNvc"
import bW9udGhXaXNlQ2 from "store/bW9udGhXaXNlQ2"
import cGVuZGluZ1By from "store/cGVuZGluZ1By"
import dGlja2V0X2xhYmVs from "store/dGlja2V0X2xhYmVs"
import dGlja2V0U3 from "store/dGlja2V0U3"
import Y2FsbENyaXR from "store/Y2FsbENyaXR"
import ZGVsaXZlcm from "store/ZGVsaXZlcm"
import bmV3TWFuYWdlTGVhZA from "store/bmV3TWFuYWdlTGVhZA"
import bmV3TXlMZWFk from "store/bmV3TXlMZWFk"
import bmV3VW5hc3NpZ25lZExlYWQ from "store/bmV3VW5hc3NpZ25lZExlYWQ"
import dGlja2V0R3Jv from "store/dGlja2V0R3Jv"
import ZG9ybWFudEN from "store/ZG9ybWFudEN"
import Y2xpZW50RGV0YWl from "store/Y2xpZW50RGV0YWl"
//Print pl on hold
import cHJpbnRPbkhvbGQ from "store/cHJpbnRPbkhvbGQ"
import dmlkZW9UZWF from "store/dmlkZW9UZWF"
import b2dUZWFtU from "store/b2dUZWFtU"
import ZnJhbWVUZWFtUHJvZHV from "store/ZnJhbWVUZWFtUHJvZHV"
import cmV0b3VjaF from "store/cmV0b3VjaF"
import bWFnYXppbm from "store/bWFnYXppbm"
import cGxQcm9kdWN0U3RhdHVzQW from "store/cGxQcm9kdWN0U3RhdHVzQW"
import cGxQcm9kdWN0U3RhdHVzUmVw from "store/cGxQcm9kdWN0U3RhdHVzUmVw"
import cHJpbnRQbFJl from "store/cHJpbnRQbFJl"
import cHJpbnRQbFByaW50Q from "store/cHJpbnRQbFByaW50Q"
import cHJpbnRQbE5vd from "store/cHJpbnRQbE5vd"
import Y3JtUHJpbnRSZXR1cm4 from "store/Y3JtUHJpbnRSZXR1cm4"
import Y3Jvc3NQcm9tb3Rpb25zTGV from "store/Y3Jvc3NQcm9tb3Rpb25zTGV"
import bWFuYWdlUHJpbnQ from "store/bWFuYWdlUHJpbnQ"

//Print Deliverable Mode
import cHJpbnRfZGVsaXZlcm from "store/cHJpbnRfZGVsaXZlcm"
import { isEmpty } from "lodash"
import ZW1wbG95ZWU from "store/ZW1wbG95ZWU"
import bGVhZENsaWVudER from "store/bGVhZENsaWVudER"
import bWFuYWdlSXNzdWVz from 'store/bWFuYWdlSXNzdWVz'
import bXlJc3N1ZXM from 'store/bXlJc3N1ZXM'
import b3BlcmF0aW9uc01hbmFnZUZ from "store/b3BlcmF0aW9uc01hbmFnZUZ"
import b3BlcmF0aW9uc015Rm9sbG9 from "store/b3BlcmF0aW9uc015Rm9sbG9"
import bWFuYWdlRW1z from "store/bWFuYWdlRW1z"
import ZW1zUmVzZXRQYXNzd29yZA from "store/ZW1zUmVzZXRQYXNzd29yZA"
import bGVhZF9zdWJzdGF0dXM from 'store/bGVhZF9zdWJzdGF0dXM'
import ZGF0YVRlYW1SZXBvcnQ from 'store/ZGF0YVRlYW1SZXBvcnQ'
import YWxidW1UZWFtUHJvZHVjdGl2aXR5 from 'store/YWxidW1UZWFtUHJvZHVjdGl2aXR5'
import b25zZWFzb24 from 'store/b25zZWFzb24'
import b3BlcmF0aW9uRm9sbG93dXBDb21w from "store/b3BlcmF0aW9uRm9sbG93dXBDb21w"
import Zm9sbG93dXBVcGxvYWQ from "store/Zm9sbG93dXBVcGxvYWQ"
import c2FsZXNQeXJhbWlkUm from "store/c2FsZXNQeXJhbWlkUm"
import ZW1wbG95ZWVJbnN0 from "store/ZW1wbG95ZWVJbnN0"
import ZGVsaXZlcmFibGVfZ from "store/ZGVsaXZlcmFibGVfZ"
import cHJvZHVjdERldGFpb from "store/cHJvZHVjdERldGFpb"
import Zm9sbG93dX from "store/Zm9sbG93dX"
import bGVhZEF2ZXJhZ2VS from "store/bGVhZEF2ZXJhZ2VS"
import bWlzc2VkRm9sbG93d from "store/bWlzc2VkRm9sbG93d"
import cHJvZHVjdERldGF from "store/cHJvZHVjdERldGF"
import ZmxyUGVuZGluZ0 from "store/ZmxyUGVuZGluZ0"
import Y3JtV2lzZUZvbGxvd3 from "store/Y3JtV2lzZUZvbGxvd3"
import b3RoZXJCcmFuY2hEY from "store/b3RoZXJCcmFuY2hEY"
import ZXZlbnRXaXNlRGF0 from "store/ZXZlbnRXaXNlRGF0"
import Y3JtV2lzZVByb2R1Y3RT from "store/Y3JtV2lzZVByb2R1Y3RT"
import ZGF0YUNvcHlEZWxldGVk from "store/ZGF0YUNvcHlEZWxldGVk"
import ZXdRdWV1ZVBsYW5uaW5nUmVwb3J0 from "store/ZXdRdWV1ZVBsYW5uaW5nUmVwb3J0"

const schemaNew = [

  //lead client details report
  {
    schemaId: "bGVhZENsaWVudER",
    name: "leadClientDetailsReport",
    title: "Lead Client Details Report",
    formTitle: "Lead Client Details Report",
    path: "/lead-client-details-report",
    visible: true,
    ...bGVhZENsaWVudER,
    page: "LeadClientDetailsReport",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },

      ]
    },
  },
  //manage high value lead
  {
    schemaId: "ZW1wbG95ZWVSZXBvcnQ",
    name: "employeeReport",
    title: "Employee Report",
    path: "/employee-report",
    visible: true,
    formTitle: "Employee Report",
    page: "employeeReport",
    ...ZW1wbG95ZWVSZXBvcnQ,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //manage print vendor
  {
    schemaId: "bWFuYWdlUHJpbnRWZW5k",
    name: "managePrintVendor",
    title: "ManagePrintVendor",
    path: "/manage-print-vendor",
    visible: true,
    formTitle: "ManagePrintVendor",
    page: "ManagePrintVendor",
    ...bWFuYWdlUHJpbnRWZW5k,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: true,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shiftName",
        label: "Shift Name",
        placeholder: "Enter Shift Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>{row.shiftName} </span>
          )
        },
        type: "text",
      },
      {
        id: "5",
        value: "fromTiming",
        label: "From Timing",
        placeholder: "Enter From Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },

      {
        id: "6",
        value: "toTiming",
        label: "To Timing",
        placeholder: "Enter To Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: " bWFuYWdlTmVhcmVzdEV2ZW",
    name: "manageNearestEvent",
    title: "Manage Nearest Event",
    path: "/manage-nearest-event",
    visible: true,
    formTitle: "Manage Nearest Event",
    page: "ManageNearestEvent",
    ...bWFuYWdlTmVhcmVzdEV2ZW,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "aW5wcm9ncmVzc1NlbnQ",
    name: "inprogressSent",
    title: "Inprogress Sent",
    path: "/ticket-inprogress-sent",
    visible: true,
    formTitle: "Inprogress Sent",
    page: "Inprogress Sent",
    ...aW5wcm9ncmVzc1NlbnQ,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "Y29tcGxldGVkU2VudA",
    name: "completedSent",
    title: "Completed Sent",
    path: "/completed-sent",
    visible: true,
    formTitle: "Completed Sent",
    page: "Completed Sent",
    ...Y29tcGxldGVkU2VudA,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "aW5wcm9ncmVzc1JlY2VpdmVk",
    name: "inprogressReceived",
    title: "Inprogress Received",
    path: "/ticket-inprogress-received",
    visible: true,
    formTitle: "Inprogress Received",
    page: "Inprogress Received",
    ...aW5wcm9ncmVzc1JlY2VpdmVk,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "Y29tcGxldGVkUmVjZWl2ZWQ",
    name: "completedReceived",
    title: "Completed Received",
    path: "/completed-received",
    visible: true,
    formTitle: "Completed Received",
    page: "Completed Received",
    ...Y29tcGxldGVkUmVjZWl2ZWQ,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "Y29tcGxldGVkQ2M",
    name: "completedCc",
    title: "Completed Cc",
    path: "/completed-cc",
    visible: true,
    formTitle: "Completed Cc",
    page: "Completed Cc",
    ...Y29tcGxldGVkQ2M,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "aW5wcm9ncmVzc0Nj",
    name: "inprogressCc",
    title: "Inprogress CC",
    path: "/tickets-inprogress-cc",
    visible: true,
    formTitle: "Inprogress CC",
    page: "Inprogress CC",
    ...aW5wcm9ncmVzc0Nj,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "bXlOZWFyZXN0RXZlbnRz",
    name: "myNearestEvents",
    title: "My Nearest Event",
    path: "/my-nearest-event",
    visible: true,
    formTitle: "My Nearest Event",
    page: "MyNearestEvents",
    ...bXlOZWFyZXN0RXZlbnRz,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //Operations
  {
    schemaId: "cHJlUGVuZGluZ1NoYXJl",
    name: "prePendingShare",
    title: "Pre Pending To Share",
    path: "/pre-pending-to-share",
    visible: true,
    formTitle: "Pre Pending To Share",
    page: "PrePendingToShare",
    ...cHJlUGVuZGluZ1NoYXJl,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "cHJlU2hhcmVkQ2xpZW",
    name: "preSharedClient",
    title: "Pre Shared To Client",
    path: "/pre-shared-to-client",
    visible: true,
    formTitle: "Pre Shared To Client",
    page: "PreSharedToClient",
    ...cHJlU2hhcmVkQ2xpZW,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "cG9zdFNoYXJlZF",
    name: "postSharedToClient",
    title: "Post Shared To Client",
    path: "/post-shared-to-client",
    visible: true,
    formTitle: "Post Shared To Client",
    page: "PostSharedToClient",
    ...cG9zdFNoYXJlZF,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "cG9zdFBlbmRpbm",
    name: "postPendingToShare",
    title: "Post Pending To Share",
    path: "/post-pending-to-share",
    visible: true,
    formTitle: "Post Pending To Share",
    page: "PostPendingToShare",
    ...cG9zdFBlbmRpbm,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "bXlDbGllbnRRY0Nvb",
    name: "myClientQcCompleted",
    title: "My Client Qc Completed",
    path: "/client-qc-completed",
    visible: true,
    formTitle: "My Client Qc Completed",
    page: "myClientQcCompleted",
    ...bXlDbGllbnRRY0Nvb,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "bXlDbGllbnRTaGFy",
    name: "myClientSharedToClient",
    title: "My Client Shared To Client",
    path: "/client-shared-to-client",
    visible: true,
    formTitle: "My Client Shared To Client",
    page: "myClientSharedToClient",
    ...bXlDbGllbnRTaGFy,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "ZXZlbnRDYW5jZWw",
    name: "eventCancel",
    title: "Event Cancelled List",
    path: "/event-cancelled-list",
    visible: true,
    formTitle: "Event Cancelled List",
    page: "EventCancel",
    ...ZXZlbnRDYW5jZWw,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //crm print start

  {
    schemaId: "Y3JtUHJpbnRQZW",
    name: "crmPrintPending",
    title: "Crm Print Pending",
    path: "/crm-print-assigned",
    visible: true,
    formTitle: "Crm Print Pending",
    page: "CrmPrintPending",
    ...Y3JtUHJpbnRQZW,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "Y3JtUHJpbnREa",
    name: "crmPrintDispatched",
    title: "Crm Print Dispatched",
    path: "/crm-rework",
    visible: true,
    formTitle: "Crm Print Dispatch",
    page: "CrmPrintDispatch",
    ...Y3JtUHJpbnREa,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "Y3JtUHJpbnREaXNwY",
    name: "crmPrintDispatchPending",
    title: "Crm Print Dispatch Pending",
    path: "/crm-print-on-hold",
    visible: true,
    formTitle: "Crm Print Dispatch Pending",
    page: "CrmPrintDispatchPending",
    ...Y3JtUHJpbnREaXNwY,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "Y3JtUHJpbnREZWxp",
    name: "crmPrintDelivered",
    title: "Crm Print Delivered",
    path: "/crm-delivered",
    visible: true,
    formTitle: "Crm Print Delivered",
    page: "CrmPrintDelivered",
    ...Y3JtUHJpbnREZWxp,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //print pl start

  {
    schemaId: "cHJpbnRQbERpc3",
    name: "printPlDispatchPending",
    title: "Print Pl Dispatch Pending",
    path: "/pl-print-rework",
    visible: true,
    formTitle: "Print Pl Dispatch Pending",
    page: "PrintPlDispatchPending",
    ...cHJpbnRQbERpc3,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "cHJpbnRQbERpc3Bhd",
    name: "printPlDispatched",
    title: "Print Pl Dispatched",
    path: "/pl-dispatch",
    visible: true,
    formTitle: "Print Pl Dispatched",
    page: "PrintPlDispatched",
    ...cHJpbnRQbERpc3Bhd,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "cHJpbnRQbFVuQXN",
    name: "printPlUnAssigned",
    title: "Print Pl UnAssigned",
    path: "/pl-print-unassigned",
    visible: true,
    formTitle: "Print Pl UnAssigned",
    page: "PrintPlUnAssigned",
    ...cHJpbnRQbFVuQXN,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "cHJpbnRQbFByaW50U",
    name: "printPlPrintPending",
    title: "Print Pl Print Pending",
    path: "/pl-print-vendor-queue",
    visible: true,
    formTitle: "Print Pl Print Pending",
    page: "PrintPlPrintPending",
    ...cHJpbnRQbFByaW50U,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //Qc Recheck list
  {
    schemaId: "cWNSZWNoZWNrTGlzdA",
    name: "qcRecheckList",
    title: "QC Recheck List",
    path: "/qc-recheck-list",
    visible: true,
    formTitle: "QC Recheck List",
    page: "QcRecheckList",
    ...cWNSZWNoZWNrTGlzdA,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //Ticket Closed
  {
    schemaId: "dGlja2V0Q2xvc2Vk",
    name: "ticketClosed",
    title: "Ticket Closed",
    path: "/ticket-my-closed",
    visible: true,
    formTitle: "Ticket Closed",
    page: "TicketClosed",
    ...dGlja2V0Q2xvc2Vk,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //Freelancer QC
  {
    schemaId: "ZnJlZWxhbmNlclFj",
    name: "freelancerQc",
    title: "Freelancer Qc",
    path: "/freelancer-qc",
    visible: true,
    formTitle: "Freelancer Qc",
    page: "FreelancerQc",
    ...ZnJlZWxhbmNlclFj,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //Freelancer Audit QC
  {
    schemaId: "ZnJlZWxhbmNlckF1ZGl0UWM",
    name: "freelancerAuditQc",
    title: "Freelancer Audit Qc",
    path: "/freelancer-audit-qc",
    visible: true,
    formTitle: "Freelancer Audit Qc",
    page: "FreelancerAuditQc",
    ...ZnJlZWxhbmNlckF1ZGl0UWM,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "c2hvb3RlclJlcG9ydA",
    name: "shooterQuantity",
    title: "Shooter Quantity",
    path: "/shooter-quantity",
    visible: true,
    formTitle: "Shooter Quantity",
    page: "ShooterQuantity",
    ...c2hvb3RlclJlcG9ydA,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "c2hvb3RlckF2YWlsYWJpbGl0eQ",
    name: "shooterAvailability",
    title: "Shooter Availability",
    path: "/shooter-available-list",
    visible: true,
    formTitle: "Shooter Availability",
    page: "ShooterAvailability",
    ...c2hvb3RlckF2YWlsYWJpbGl0eQ,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //password setup
  {
    schemaId: "cGFzc3dvcmRTZXR1cA",
    name: "passwordSetup",
    title: "PasswordSetup",
    path: "/password-setup",
    visible: true,
    formTitle: "Password Setup",
    page: "PasswordSetup",
    ...cGFzc3dvcmRTZXR1cA,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: true,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shiftName",
        label: "Shift Name",
        placeholder: "Enter Shift Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>{row.shiftName} </span>
          )
        },
        type: "text",
      },
      {
        id: "5",
        value: "fromTiming",
        label: "From Timing",
        placeholder: "Enter From Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },

      {
        id: "6",
        value: "toTiming",
        label: "To Timing",
        placeholder: "Enter To Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },

  {
    schemaId: "YmRtQWNjb3",
    path: "/bdm-account",
    name: "bdmAccountSetUp",
    title: "Bdm-Account Setup",
    formTitle: "Bdm-Account Setup",
    visible: true,
    ...YmRtQWNjb3,
    page: "ManageBdmAccount",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          label: "Source Code",
          autofillValue: codeValueMetaData,
          placeholder: "Enter Source Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "code",
        },
        {
          id: "5",
          value: "sourceName",
          label: "Source Name",
          placeholder: "Enter Source Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,

          type: "text",
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
              </>
            )
          },
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //password setup
  {
    schemaId: "YmRtUGFzc3",
    name: "bdmPasswordSetup",
    title: "BdmPasswordSetup",
    path: "/bdm-reset-password",
    visible: true,
    formTitle: "BdmPasswordSetup",
    page: "BdmPasswordSetup",
    ...YmRtUGFzc3,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: true,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shiftName",
        label: "Shift Name",
        placeholder: "Enter Shift Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>{row.shiftName} </span>
          )
        },
        type: "text",
      },
      {
        id: "5",
        value: "fromTiming",
        label: "From Timing",
        placeholder: "Enter From Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },

      {
        id: "6",
        value: "toTiming",
        label: "To Timing",
        placeholder: "Enter To Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "YmRtU291cmNlU3RhdHVz",
    name: "bdmSourceStatus",
    title: "Bdm Source Status",
    path: "/bdm-source-status",
    visible: true,
    formTitle: "Bdm Source Status",
    page: "BdmSourceStatus",
    ...YmRtU291cmNlU3RhdHVz,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: true,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shiftName",
        label: "Shift Name",
        placeholder: "Enter Shift Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>{row.shiftName} </span>
          )
        },
        type: "text",
      },
      {
        id: "5",
        value: "fromTiming",
        label: "From Timing",
        placeholder: "Enter From Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },

      {
        id: "6",
        value: "toTiming",
        label: "To Timing",
        placeholder: "Enter To Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "bGVhZFNvdXJjZVN0YXR1cw",
    name: "leadSourceStatus",
    title: "Lead Source Status",
    path: "/lead-source-status",
    visible: true,
    formTitle: "Lead Source Status",
    page: "LeadSourceStatus",
    ...bGVhZFNvdXJjZVN0YXR1cw,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: true,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shiftName",
        label: "Shift Name",
        placeholder: "Enter Shift Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>{row.shiftName} </span>
          )
        },
        type: "text",
      },
      {
        id: "5",
        value: "fromTiming",
        label: "From Timing",
        placeholder: "Enter From Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },

      {
        id: "6",
        value: "toTiming",
        label: "To Timing",
        placeholder: "Enter To Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },

  {
    schemaId: "b3BlcmF0aW9uc0",
    path: "/operations-followup",
    name: "operationsFollowUp",
    title: "OperationFollowUp",
    formTitle: "OperationFollowUp",
    visible: true,
    ...b3BlcmF0aW9uc0,
    page: "OperationFollowup",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          label: "Source Code",
          autofillValue: codeValueMetaData,
          placeholder: "Enter Source Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "code",
        },
        {
          id: "5",
          value: "sourceName",
          label: "Source Name",
          placeholder: "Enter Source Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,

          type: "text",
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
              </>
            )
          },
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "c3RkQXJjaGl",
    name: "stdArchieve",
    title: "Std Archieve",
    formTitle: "Std Archieve",
    path: "/std-archieve",
    visible: true,
    ...c3RkQXJjaGl,
    page: "StdArchieve",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "documentName",
        label: "Document Name",
        placeholder: "Enter Document Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <>
              <span style={{ textTransform: "uppercase" }}>
                {row.documentName}
              </span>
            </>
          )
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "5",
        value: "description",
        label: "Description",
        placeholder: "Enter Description ",
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return (
            <>
              <span style={{ textTransform: "uppercase" }}>
                {row.description}
              </span>
            </>
          )
        },
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },

  {
    schemaId: "bXlOZWFyRnV0d",
    name: "myNearFutureEvent",
    title: "My Near Future Event",
    path: "/my-nearest-events",
    visible: true,
    formTitle: "MyNearFutureEvent",
    page: "MyNearFutureEvent",
    ...bXlOZWFyRnV0d,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "Z2V0UGhvdG9",
    name: "getPhotographerAppDetails",
    title: "GetPhotographerAppDetails ",
    formTitle: "GetPhotographerAppDetails ",
    path: "/photographer-app-details",
    visible: true,
    ...Z2V0UGhvdG9,
    page: "GetPhotographerAppDetails ",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "documentName",
        label: "Document Name",
        placeholder: "Enter Document Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <>
              <span style={{ textTransform: "uppercase" }}>
                {row.documentName}
              </span>
            </>
          )
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "5",
        value: "description",
        label: "Description",
        placeholder: "Enter Description ",
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return (
            <>
              <span style={{ textTransform: "uppercase" }}>
                {row.description}
              </span>
            </>
          )
        },
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  //service quantity list
  {
    schemaId: "c2VydmljZVF1YW5",
    name: "serviceQuantityList",
    title: "ServiceQuantityList",
    path: "/service-quantity-list",
    visible: true,
    formTitle: "ServiceQuantityList",
    page: "ServiceQuantityList",
    ...c2VydmljZVF1YW5,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //freelancer services list
  {
    schemaId: "ZnJlZWxhbmNlclF1",
    name: "freelancerQuantityList",
    title: "freelancerQuantityList",
    path: "/freelancer-services-list",
    visible: true,
    formTitle: "freelancerQuantityList",
    page: "FreelancerQuantityList",
    ...ZnJlZWxhbmNlclF1,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //freelancer quantity list
  {
    schemaId: "ZnJlZWxhbmNlclF0eUxpc3Q",
    name: "freelancerQtyList",
    title: "freelancerQtyList",
    path: "/freelancer-quantity-list",
    visible: true,
    formTitle: "freelancerQtyList",
    page: "FreelancerQtyList",
    ...ZnJlZWxhbmNlclF0eUxpc3Q,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //freelancer projections list
  {
    schemaId: "ZnJlZWxhbmNlclByb2plY3Rpb25zTGlzdA",
    name: "freelancerProjectionsList",
    title: "freelancerProjectionsList",
    path: "/freelancer-projections-list",
    visible: true,
    formTitle: "freelancerProjectionsList",
    page: "FreelancerProjectionsList",
    ...ZnJlZWxhbmNlclByb2plY3Rpb25zTGlzdA,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "ZXZlbnRDbGllbn",
    name: "eventClientComplete",
    title: "EventClientComplete",
    formTitle: "EventClientComplete",
    path: "/client-completed",
    visible: true,
    ...ZXZlbnRDbGllbn,
    page: "EventClientComplete",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions
      console.log(records, "record from company list")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Company Code",
          placeholder: "Enter Company Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.code}</p>
              </>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Company Name",
          placeholder: "Enter Company Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.name}</p>
              </>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "logo",
          label: "Company Logo",
          placeholder: "Enter File Name",
          sort: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: { paddingRight: "15px" },
          },
          editRecord: true,
          formatter: (cellContent) => {
            const value = cellContent
            console.log(cellContent)
            return cellContent ? (
              <div className="" style={{ display: "flex" }}>
                {/* <i className="display-4 text-muted bx bxs-file" onClick={() => window.open(value, '_blank')} /> */}
                <img className="cls-imagepreview" src={value} alt={value}></img>
              </div>
            ) : (
              <span>Upload Logo</span>
            )
          },
          viewRecord: true,
          type: "upload",
        },
        {
          id: "7",
          value: "type",
          label: "Type",
          placeholder: "Enter Type",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "radio",
          options: [
            {
              label: "Event",
              value: "event",
            },
            {
              label: "Service",
              value: "service",
            },
          ],
          formatter: (cellContent) => {
            const data = [
              {
                label: "EVENT",
                value: "event",
              },
              {
                label: "SERVICE",
                value: "service",
              },
            ]
            return (
              (cellContent &&
                data.find((_) => _.value === cellContent).label) ||
              ""
            )
          },
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status == 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "13",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "b3BlcmF0aW9uc",
    name: "operationsLevelOne",
    title: "OperationsLevelOne",
    formTitle: "OperationsLevelOne",
    path: "/operations-level-1",
    visible: true,
    ...b3BlcmF0aW9uc,
    page: "OperationsLevelOne",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions
      console.log(records, "record from company list")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Company Code",
          placeholder: "Enter Company Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.code}</p>
              </>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Company Name",
          placeholder: "Enter Company Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.name}</p>
              </>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "logo",
          label: "Company Logo",
          placeholder: "Enter File Name",
          sort: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: { paddingRight: "15px" },
          },
          editRecord: true,
          formatter: (cellContent) => {
            const value = cellContent
            console.log(cellContent)
            return cellContent ? (
              <div className="" style={{ display: "flex" }}>
                {/* <i className="display-4 text-muted bx bxs-file" onClick={() => window.open(value, '_blank')} /> */}
                <img className="cls-imagepreview" src={value} alt={value}></img>
              </div>
            ) : (
              <span>Upload Logo</span>
            )
          },
          viewRecord: true,
          type: "upload",
        },
        {
          id: "7",
          value: "type",
          label: "Type",
          placeholder: "Enter Type",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "radio",
          options: [
            {
              label: "Event",
              value: "event",
            },
            {
              label: "Service",
              value: "service",
            },
          ],
          formatter: (cellContent) => {
            const data = [
              {
                label: "EVENT",
                value: "event",
              },
              {
                label: "SERVICE",
                value: "service",
              },
            ]
            return (
              (cellContent &&
                data.find((_) => _.value === cellContent).label) ||
              ""
            )
          },
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status == 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "13",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //product status service
  {
    schemaId: "cHJvZHVjdFN0",
    name: "productStatusReport",
    title: "ProductStatusReport",
    path: "/product-status-report",
    visible: true,
    formTitle: "ProductStatusReport",
    page: "ProductStatusReport",
    ...cHJvZHVjdFN0,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "Y2xpZW50Vmlza",
    name: "clientVisitReport",
    title: "ClientVisitReport",
    path: "/client-visit-report",
    visible: true,
    formTitle: "ClientVisitReport",
    page: "ClientVisitReport",
    ...Y2xpZW50Vmlza,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //product status aging report
  {
    schemaId: "cHJvZHVjdFN0YXR1c0",
    name: "productStatusAgingReport",
    title: "productStatusAgingReport",
    path: "/product-status-aging",
    visible: true,
    formTitle: "productStatusAgingReport",
    page: "ProductStatusAgingReport",
    ...cHJvZHVjdFN0YXR1c0,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //ew wise deliverable status
  {
    schemaId: "ZXdXaXNlRG",
    name: "ewWiseDeliverableStatus",
    title: "EwWiseDeliverableStatus",
    path: "/ew-wise-deliverable-status",
    visible: true,
    formTitle: "EwWiseDeliverableStatus",
    page: "EwWiseDeliverableStatus",
    ...ZXdXaXNlRG,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //post client pending
  {
    schemaId: "cG9zdENsaW",
    name: "postClientPending",
    title: "PostClientPending",
    path: "/post-client-pending",
    visible: true,
    formTitle: "PostClientPending",
    page: "PostClientPending",
    ...cG9zdENsaW,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //crm wise client pending
  {
    schemaId: "Y3JtV2lzZVBlbmR",
    name: "crmWisePendingClientCount",
    title: "Crm Wise Pending Client Count",
    path: "/crm-wise-client-count",
    visible: true,
    formTitle: "CrmWisePendingClientCount",
    page: "CrmWisePendingClientCount",
    ...Y3JtV2lzZVBlbmR,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //month wise client pending

  {
    schemaId: "bW9udGhXaX",
    name: "monthWiseClientDeliverable",
    title: "MonthWiseClientDeliverable",
    path: "/month-wise-client-deliverable-status",
    visible: true,
    formTitle: "MonthWiseClientDeliverable",
    page: "MonthWiseClientDeliverable",
    ...bW9udGhXaX,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //crm post on hold
  {
    schemaId: "cG9zdENybU9uSG",
    name: "postCrmOnHold",
    title: "PostCrmOnHold",
    path: "/month-wise-client-deliverable-status",
    visible: true,
    formTitle: "PostCrmOnHold",
    page: "PostCrmOnHold",
    ...cG9zdENybU9uSG,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //client on hold
  {
    schemaId: "bXlDbGllbnRPb",
    name: "myClientOnHold",
    title: "mmyClientOnHold",
    path: "/client-on-hold",
    visible: true,
    formTitle: "MyClientOnHold",
    page: "MyClientOnHold",
    ...bXlDbGllbnRPb,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "bW9udGhXaXNlUGVu",
    name: "monthWisePendingClientCount",
    title: "monthWisePendingClientCount",
    path: "/month-wise-pending-client-count",
    visible: true,
    formTitle: "monthWisePendingClientCount",
    page: "MonthWisePendingClientCount",
    ...bW9udGhXaXNlUGVu,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //my works on hold

  {
    schemaId: "bXlXb3Jrc09uSG9s",
    name: "myWorksOnHold",
    title: "myWorksOnHold",
    path: "/on-hold",
    visible: true,
    formTitle: "myWorksOnHold",
    page: "MyWorksOnHold",
    ...bXlXb3Jrc09uSG9s,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //post not applicable

  {
    schemaId: "cG9zdE5vdEFw",
    name: "postNotApplicable",
    title: "postNotApplicable",
    path: "/not-applicable",
    visible: true,
    formTitle: "postNotApplicable",
    page: "PostNotApplicable",
    ...cG9zdE5vdEFw,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //my client qc recheck
  {
    schemaId: "bXlDbGllbnRRY",
    name: "myClientQcRecheck",
    title: "myClientQcRecheck",
    path: "/client-qc-recheck",
    visible: true,
    formTitle: "myClientQcRecheck",
    page: "MyClientQcRecheck",
    ...bXlDbGllbnRRY,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //my works qc recheck
  {
    schemaId: "bXlXb3Jrc1Fj",
    name: "myWorksQcRecheck",
    title: "myWorksQcRecheck",
    path: "/ew-qc-recheck",
    visible: true,
    formTitle: "myWorksQcRecheck",
    page: "MyWorksQcRecheck",
    ...bXlXb3Jrc1Fj,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //post qc recheck
  {
    schemaId: "cG9zdFFjUmVja",
    name: "postQcRecheck",
    title: "postQcRecheck",
    path: "/post-qc-recheck",
    visible: true,
    formTitle: "postQcRecheck",
    page: "PostQcRecheck",
    ...cG9zdFFjUmVja,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //crm wise product status report

  {
    schemaId: "Y3JtV2lzZVByb",
    name: "crmWiseProductStatusReport",
    title: "CrmWiseProductStatusReport",
    path: "/crm-wise-product-status",
    visible: true,
    formTitle: "CrmWiseProductStatusReport",
    page: "CrmWiseProductStatusReport",
    ...Y3JtV2lzZVByb,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //event month wise product status report
  {
    schemaId: "ZXZlbnRNb250",
    name: "eventMonthWiseProductStatusReport",
    title: "eventMonthWiseProductStatusReport",
    path: "/event-month-wise-product-status",
    visible: true,
    formTitle: "eventMonthWiseProductStatusReport",
    page: "EventMonthWiseProductStatusReport",
    ...ZXZlbnRNb250,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //ew wise product status report
  {
    schemaId: "ZXdXaXNlUH",
    name: "ewWiseProductStatusReport",
    title: "Ew Wise Product Status Report",
    path: "/ew-wise-product-status",
    visible: true,
    formTitle: "Ew Wise Product Status Report",
    page: "EwWiseProductStatusReport",
    ...ZXdXaXNlUH,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },

    //data copy
  },
  {
    schemaId: "Y29weURhdGE",
    name: "copyData",
    title: "CopyData",
    path: "/copy-data",
    visible: true,
    formTitle: "CopyData",
    page: "CopyDataNew",
    ...Y29weURhdGE,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //service level status

  {
    schemaId: "c2VydmljZV9sZX",
    name: "service_level_status",
    title: "Service Level Status",
    formTitle: "Service Level Status",
    path: "/service-level-status",
    visible: true,
    ...c2VydmljZV9sZX,
    page: "ServiceLevelStatus",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "serviceLevelName",
          label: "Service Level Name",
          placeholder: "Enter Service",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.serviceLevelName}{" "}
              </span>
            )
          },
        },

        // {
        //   id: "6",
        //   value: 'shortCode',
        //   label: 'Short Code ',
        //   autofillValue: codeValueMetaData,
        //   placeholder: 'Enter Short Code',
        //   sort: true,
        //   editRecord: true,
        //   viewRecord: true,
        //   //required: false,
        //   formatter: (cellContent, row) => {
        //     return <span style={{ textTransform: "uppercase" }}>{row.shortCode} </span>
        //   },
        //   type: 'code'
        // },
        {
          id: "5",
          value: "shortCode",
          label: "Short Code",
          placeholder: "Enter Short Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.shortCode}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "colorCode",
          label: "Color Code",
          placeholder: "Enter Color Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.colorCode}{" "}
              </span>
            )
          },
        },
        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: true,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "ZGF0YUNvc",
    name: "dataCopyCompleted",
    title: "DataCopyCompleted",
    path: "/data-copy-completed",
    visible: true,
    formTitle: "DataCopyCompleted",
    page: "DataCopyCompleted",
    ...ZGF0YUNvc,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //Month wise client closure

  {
    schemaId: "bW9udGhXaXNlQ2",
    name: "monthWiseClientClosureReport",
    title: "MonthWiseClientClosureReport",
    path: "/ew-wise-product-status",
    visible: true,
    formTitle: "MonthWiseClientClosureReport",
    page: "MonthWiseClientClosureReport",
    ...bW9udGhXaXNlQ2,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //pendingProductWIseClientCount

  {
    schemaId: "cGVuZGluZ1By",
    name: "pendingProductWIseClientCount",
    title: "PendingProductWIseClientCount",
    path: "/pending-product-wise-client-count",
    visible: true,
    formTitle: "PendingProductWIseClientCount",
    page: "PendingProductWIseClientCount",
    ...cGVuZGluZ1By,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //ticket summary
  {
    schemaId: "dGlja2V0U3",
    name: "ticketSummary",
    title: "Ticket Summary",
    formTitle: "Ticket Summary",
    path: "/ticket-summary",
    visible: true,
    ...dGlja2V0U3,
    page: "TicketSummary",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "labelName",
          label: "Label Name",
          placeholder: "Enter Service",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.labelName}{" "}
              </span>
            )
          },
        },

        {
          id: "5",
          value: "shortCode",
          label: "Short Code",
          placeholder: "Enter Short Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.shortCode}{" "}
              </span>
            )
          },
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: true,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "dGlja2V0X2xhYmVs",
    name: "ticket_label",
    title: "Ticket Label",
    formTitle: "Ticket Label",
    path: "/ticket-label",
    visible: true,
    ...dGlja2V0X2xhYmVs,
    page: "TicketLabel",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "labelName",
          label: "Label Name",
          placeholder: "Enter Service",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.labelName}{" "}
              </span>
            )
          },
        },

        {
          id: "5",
          value: "shortCode",
          label: "Short Code",
          placeholder: "Enter Short Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.shortCode}{" "}
              </span>
            )
          },
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: true,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //call criteria and action
  {
    schemaId: "Y2FsbENyaXR",
    name: "CallCriteria",
    title: "Call Criteria & Action",
    formTitle: "Call Criteria & Action",
    path: "/call-criteria-action",
    visible: true,
    ...Y2FsbENyaXR,
    page: "CallCriteriaAction",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions
      const typeOptions = [
        {
          value: "ACTION",
          label: "ACTION",
        },
        {
          value: "CRITERIA",
          label: "CRITERIA",
        },
      ]
      console.log(codeValueMetaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "type",
          label: "Type",
          placeholder: "Enter Type",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // type: 'text',
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.type} </span>
            )
          },
          type: "select",
          options: typeOptions,
        },

        {
          id: "5",
          value: "criteriaName",
          label: "Criteria Name",
          placeholder: "Enter CriteriaName",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.criteriaName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "shortNotes",
          label: "Short Notes",
          placeholder: "Enter Short Notes",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.shortNotes}{" "}
              </span>
            )
          },
        },
        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          // required: true,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "ZGVsaXZlcm",
    name: "DeliverableTag",
    title: "Deliverable Tags",
    formTitle: "Deliverable Tags",
    path: "/deliverable-tags",
    visible: true,
    ...ZGVsaXZlcm,
    page: "DeliverableTags",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, metaData, "record from api")

      // const codeValueMetaData = metaData && metaData.codeOptions

      // console.log(codeValueMetaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "5",
          value: "deliverableTag",
          label: "Deliverable Tag",
          placeholder: "Enter Deliverable Tag",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.deliverableTag}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "deliverableProductCategoryId",
          label: "Deliverable Product Category",
          placeholder: "Select Deliverable Product Category",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "select",
          required: true,
          formatter: (cellContent, row) => {
            // const categoryName =
            //   metaData &&
            //   metaData.productOptions &&
            //   metaData.productOptions.length > 0 &&
            //   row.deliverableProductCategoryId
            //     ? metaData.productOptions.find(
            //         (data) => data.value == row.deliverableProductCategoryId
            //       )
            //     : ""
            //     console.log(categoryName, "categoryName")
            //     console.log(metaData, "metaData")
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.deliverableProductCategoryName}{" "}
              </span>
            )
          },
          options: "productOptions",
        },

        {
          id: "5",
          value: "shortNotes",
          label: "Short Notes",
          placeholder: "Enter Short Notes",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: false,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.shortNotes}{" "}
              </span>
            )
          },
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "cHJpbnRfZGVsaXZlcm",
    name: "print_deliverable_mode",
    title: "Print Deliverable Mode",
    formTitle: "Print Deliverable Mode",
    path: "/print-deliverable-mode",
    visible: true,
    ...cHJpbnRfZGVsaXZlcm,
    page: "PrintDeliverableMode",
    exact: true,
    columns: (records = []) => {
      console.log(records, "record from api")
      const deliveryModeOptions = [
        {
          label: "Dispatch Hold",
          value: "dispatchHold",
        },
        {
          label: "Mode Of Dispatch",
          value: "modeOfDispatch",
        },
        {
          label: "Print Return",
          value: "printReturn",
        },
      ]
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "5",
          value: "mode",
          label: "Mode",
          placeholder: "Select Mode",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "select",
          required: true,
          formatter: (cellContent, row) => {
            const modeValue =
              !isEmpty(row) && row.mode && deliveryModeOptions.length > 0
                ? deliveryModeOptions.find((data) => data.value == row.mode)
                : ""
            console.log(modeValue, "modeValue")
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.mode && !isEmpty(modeValue) ? modeValue.label : ""}{" "}
              </span>
            )
          },
          options: deliveryModeOptions,
        },

        {
          id: "5",
          value: "detailName",
          label: "Details Name",
          placeholder: "Enter Details Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.detailName}{" "}
              </span>
            )
          },
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          // required: true,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "bmV3TWFuYWdlTGVhZA",
    name: "newManageLead",
    title: "New Manage Lead",
    path: "/new-manage-lead ",
    visible: true,
    formTitle: "New Manage Lead",
    page: "NewManageLead",
    ...bmV3TWFuYWdlTGVhZA,
    // grid: [
    //   {
    //     id: 1,
    //     component: LeadHeader,
    //   },
    // ],
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "bmV3TXlMZWFk",
    name: "newMyLead",
    title: "New My Lead",
    path: "/my-lead ",
    visible: true,
    formTitle: "New My Lead",
    page: "NewMyLead",
    ...bmV3TXlMZWFk,
    // grid: [
    //   {
    //     id: 1,
    //     component: LeadHeader,
    //   },
    // ],
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "bmV3VW5hc3NpZ25lZExlYWQ",
    name: "newUnassignedLead",
    title: "New Unassigned Lead",
    path: "/new-unassigned-lead ",
    visible: true,
    formTitle: "New Unassigned Lead",
    page: "NewUnassignedLead",
    ...bmV3VW5hc3NpZ25lZExlYWQ,
    // grid: [
    //   {
    //     id: 1,
    //     component: LeadHeader,
    //   },
    // ],
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "Y3Jvc3NQcm9tb3Rpb25zTGV",
    name: "crossPromotionsLead",
    title: "Cross Promotions Lead",
    path: "/cross-promotions-lead ",
    visible: true,
    formTitle: "Cross Promotions Lead",
    page: "CrossPromotionsLead",
    ...Y3Jvc3NQcm9tb3Rpb25zTGV,
    // grid: [
    //   {
    //     id: 1,
    //     component: LeadHeader,
    //   },
    // ],
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //ticket grouping
  {
    schemaId: "dGlja2V0R3Jv",
    name: "ticket_group",
    title: "Ticket Grouping",
    formTitle: "Ticket Grouping",
    path: "/ticket-grouping",
    visible: true,
    ...dGlja2V0R3Jv,
    page: "TicketGrouping",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "ZG9ybWFudEN",
    name: "dormantClient",
    title: "Dormant Client",
    formTitle: "Dormant Client",
    path: "/dormant-client",
    visible: true,
    ...ZG9ybWFudEN,
    page: "DormantClient",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //client details report
  {
    schemaId: "Y2xpZW50RGV0YWl",
    name: "clientDetailsReport",
    title: "Client Details Report",
    formTitle: "Client Details Report",
    path: "/client-details-report",
    visible: true,
    ...Y2xpZW50RGV0YWl,
    page: "ClientDetailsReport",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "cHJpbnRPbkhvbGQ",
    name: "printOnHold",
    title: "Print On Hold",
    formTitle: "Print On Hold",
    path: "/print-pl-on-hold",
    visible: true,
    ...cHJpbnRPbkhvbGQ,
    page: "PrintOnHold",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //Video Team productivity report
  {
    schemaId: "dmlkZW9UZWF",
    name: "videoTeamProductivityReport",
    title: "Video Team Productivity Report",
    formTitle: "Video Team Productivity Report",
    path: "/video-team-productivity",
    visible: true,
    ...dmlkZW9UZWF,
    page: "VideoTeamProductivityReport",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //og team
  {
    schemaId: "b2dUZWFtU",
    name: "ogTeamProductivity",
    title: "OG Team Productivity Report",
    formTitle: "OG Team Productivity Report",
    path: "/og-team-productivity",
    visible: true,
    ...b2dUZWFtU,
    page: "OgTeamProductivityReport",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //retouch team
  {
    schemaId: "cmV0b3VjaF",
    name: "retouchTeamProductivity",
    title: "Retouch Team Productivity Report",
    formTitle: "Retouch Team Productivity Report",
    path: "/retouch-team-productivity",
    visible: true,
    ...cmV0b3VjaF,
    page: "RetouchTeamProductivityReport",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //frame team
  {
    schemaId: "ZnJhbWVUZWFtUHJvZHV",
    name: "frameTeamProductivity",
    title: "Frame Team Productivity Report",
    formTitle: "Frame Team Productivity Report",
    path: "/frame-team-productivity",
    visible: true,
    ...ZnJhbWVUZWFtUHJvZHV,
    page: "FrameTeamProductivityReport",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  //magazine team
  {
    schemaId: "bWFnYXppbm",
    name: "magazineTeamProductivity",
    title: "Magazine Team Productivity",
    formTitle: "Magazine Team Productivity",
    path: "/magazine-team-productivity",
    visible: true,
    ...bWFnYXppbm,
    page: "MagazineTeamProductivity",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "cGxQcm9kdWN0U3RhdHVzUmVw",
    name: "plProductStatusReport",
    title: "Pl Product Status Report",
    path: "/pl-product-status-report",
    visible: true,
    formTitle: "Pl Product Status Report",
    page: "PlProductStatusReport",
    ...cGxQcm9kdWN0U3RhdHVzUmVw,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "cGxQcm9kdWN0U3RhdHVzQW",
    name: "plProductStatusAgingReport",
    title: "Pl Product Status Aging Report",
    path: "/pl-product-status-aging-report",
    visible: true,
    formTitle: "Pl Product Status Aging Report",
    page: "PlProductStatusAgingReport",
    ...cGxQcm9kdWN0U3RhdHVzQW,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.code}</span>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.name}</span>
            )
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },

  {
    schemaId: "cHJpbnRQbE5vd",
    name: "printPlNotApplicable",
    title: "Print Pl Not Applicable",
    formTitle: "Print Pl Not Applicable",
    path: "/print-pl-not-applicable",
    visible: true,
    ...cHJpbnRQbE5vd,
    page: "PrintPlNotApplicable",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "cHJpbnRQbFByaW50Q",
    name: "printPlPrintCompleted",
    title: "Print Pl Print Completed",
    formTitle: "Print Pl Print Completed",
    path: "/pl-print-completed",
    visible: true,
    ...cHJpbnRQbFByaW50Q,
    page: "PrintPlPrintCompleted",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "cHJpbnRQbFJl",
    name: "printPlReturn",
    title: "Print Pl Return",
    formTitle: "Print Pl Return",
    path: "/pl-return",
    visible: true,
    ...cHJpbnRQbFJl,
    page: "PrintPlReturn",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "Y3JtUHJpbnRSZXR1cm4",
    name: "crmPrintReturn",
    title: "Crm Print Return",
    formTitle: "Crm Print Return",
    path: "/crm-print-return",
    visible: true,
    ...Y3JtUHJpbnRSZXR1cm4,
    page: "CrmPrintReturn",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "5",
          value: "groupName",
          label: "Group Name",
          placeholder: "Enter Group Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.groupName}{" "}
              </span>
            )
          },
        },
        {
          id: "5",
          value: "employeeId",
          label: "Employee",
          placeholder: "Select Employee",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "multiSelect",
          validations: "arrayField",
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span>
                {row.employeeId.length > 1
                  ? row.employeeName && row.employeeName.join(", ")
                  : row.employeeName}
              </span>
            )
          },
          options: "employeeOptions",
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          required: false,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "bWFuYWdlUHJpbnQ",
    name: "managePrint",
    title: "Manage Print",
    formTitle: "Manage Print",
    path: "/manage-print-pl",
    visible: true,
    ...bWFuYWdlUHJpbnQ,
    page: "ManagePrint",
    exact: true,
    columns: (records = []) => {
      console.log(records, "record from api")
      const deliveryModeOptions = [
        {
          label: "Dispatch Hold",
          value: "dispatchHold",
        },
        {
          label: "Mode Of Dispatch",
          value: "modeOfDispatch",
        },
        {
          label: "Print Return",
          value: "printReturn",
        },
      ]
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "5",
          value: "mode",
          label: "Mode",
          placeholder: "Select Mode",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "select",
          required: true,
          formatter: (cellContent, row) => {
            const modeValue =
              !isEmpty(row) && row.mode && deliveryModeOptions.length > 0
                ? deliveryModeOptions.find((data) => data.value == row.mode)
                : ""
            console.log(modeValue, "modeValue")
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.mode && !isEmpty(modeValue) ? modeValue.label : ""}{" "}
              </span>
            )
          },
          options: deliveryModeOptions,
        },

        {
          id: "5",
          value: "detailName",
          label: "Details Name",
          placeholder: "Enter Details Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "text",
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.detailName}{" "}
              </span>
            )
          },
        },

        {
          id: "7",
          value: "description",
          label: "Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          placeholder: "Enter The Description",
          type: "textarea",
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.description}{" "}
              </span>
            )
          },
          // required: true,
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //rolesndResponsibility
  {
    schemaId: "ZW1wbG95ZWU",
    name: "employee_roles_and_responsibilities",
    title: "Roles And Responsibility",
    formTitle: "Roles And Responsibility",
    path: "/roles-responsibility",
    visible: true,
    ...ZW1wbG95ZWU,
    page: "RolesAndResponsibility",
    exact: true,
    columns: (records = []) => {
      console.log(records, "records")
      return [
        {
          id: "1",
          value: "rolesAndResponsibilities",
          label: "Roles And Responsibility",
          placeholder: "Enter Roles And Responsibility",
          sort: false,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "7",
            md: "7",
            style: { paddingRight: "15px" },
          },
          type: "textarea",
        },
        {
          id: "2",
          value: "reports",
          label: "Reports",
          placeholder: "Enter Reports",
          sort: false,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "7",
            md: "7",
            style: { paddingRight: "15px" },
          },
          type: "textarea",
        },
      ]
    },
  },
  {
    schemaId: "bWFuYWdlSXNzdWVz",
    name: "manageIssues",
    title: "Manage Issues",
    formTitle: "Manage Issues",
    path: "/manage-issues",
    visible: true,
    ...bWFuYWdlSXNzdWVz,
    page: "ManageIssues",
    exact: true,
    columns: (records = []) => {
      console.log(records, "record from api")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },

      ]
    },
  },
  {
    schemaId: "bXlJc3N1ZXM",
    name: "myIssues",
    title: "My Issues",
    formTitle: "My Issues",
    path: "/my-issues",
    visible: true,
    ...bXlJc3N1ZXM,
    page: "MyIssues",
    exact: true,
    columns: (records = []) => {
      console.log(records, "record from api")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },

      ]
    },
  },


  //operations manage followup
  {
    schemaId: "b3BlcmF0aW9uc01hbmFnZUZ",
    name: "operationsManageFollowUp",
    title: "OperationsManageFollowUp",
    path: "/operations-manage-followup",
    visible: true,
    formTitle: "OperationsManageFollowUp",
    page: "OperationsManageFollowup",
    ...b3BlcmF0aW9uc01hbmFnZUZ,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },

    ],
  },
  //operations my followup
  {
    schemaId: "b3BlcmF0aW9uc015Rm9sbG9",
    name: "operationsMyFollowUp",
    title: "OperationsMyFollowUp",
    path: "/operations-my-followup",
    visible: true,
    formTitle: "OperationsMyFollowUp",
    page: "OperationsMyFollowup",
    ...b3BlcmF0aW9uc015Rm9sbG9,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },

    ],
  },
  //ems
  {
    schemaId: "bWFuYWdlRW1z",
    name: "manageEms",
    title: "Manage Ems",
    path: "/manage-ems",
    visible: true,
    formTitle: "Manage Ems",
    page: "ManageEms",
    ...bWFuYWdlRW1z,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },

    ],
  },
  // ems reset password
  {
    schemaId: "ZW1zUmVzZXRQYXNzd29yZA",
    name: "emsResetPassword",
    title: "Ems Reset Password",
    path: "/ems-reset-password",
    visible: true,
    formTitle: "Ems Reset Password",
    page: "EmsResetPassword",
    ...ZW1zUmVzZXRQYXNzd29yZA,
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },

    ],
  },
  //lead sub status

  {
    schemaId: "bGVhZF9zdWJzdGF0dXM",
    name: 'lead_substatus',
    title: 'Lead Sub Status',
    formTitle: 'Lead Sub Status',
    path: '/lead-sub-status',
    visible: true,
    ...bGVhZF9zdWJzdGF0dXM,
    page: 'LeadSubStatus',
    exact: true,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "2",
          value: 'sno',
          label: 'S.No',
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) => row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : rowIndex + 1,
          type: 'text'
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },

        {
          id: "4",
          value: 'companyId',
          label: 'Company',
          placeholder: 'Enter Company',
          sort: true,
          required: true,
          editRecord: true,
          viewRecord: true,
          type: 'select',
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.companyOptions &&
                metaData.companyOptions.length > 0 &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          options: 'companyOptions'
        },
        {
          id: "5",
          value: 'leadSubSourceName',
          label: 'Lead Sub Status Name',
          placeholder: 'Enter Lead Sub Source Name',
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: 'text',
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{ textTransform: "uppercase" }}>{row.leadSubSourceName} </span>
          },
        },

        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: 'insertedBy',
          label: 'Inserted By',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "10",
          value: 'updatedBy',
          label: 'Updated By',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "11",
          value: 'createdAt',
          label: 'Created Date',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "12",
          value: 'updatedAt',
          label: 'Updated Date',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        }
      ]
    },
  },
  //data team report
  {
    schemaId: "ZGF0YVRlYW1SZXBvcnQ",
    name: "dataTeamReport",
    title: "Data Team Report",
    formTitle: "Data Team Report",
    path: "/data-team-report",
    visible: true,
    ...ZGF0YVRlYW1SZXBvcnQ,
    page: "DataTeamReport",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },

      ]
    },
  },
  //album team
  {
    schemaId: "YWxidW1UZWFtUHJvZHVjdGl2aXR5",
    name: "albumTeamProductivity",
    title: "Album Team Productivity",
    formTitle: "Album Team Productivity",
    path: "/album-team-productivity",
    visible: true,
    ...YWxidW1UZWFtUHJvZHVjdGl2aXR5,
    page: "AlbumTeamProductivityReport",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      console.log(metaData, "codeValueMetaData")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },

      ]
    },
  },
     // lead_service
     {
      schemaId: "b25zZWFzb24",
      name: 'onseason',
      title: 'On Season Date Mark',
      formTitle: 'On Season Date Mark',
      path: '/on-season-date-mark',
      visible: true,
      ...b25zZWFzb24,
      page: 'OnSeasonDetails',
      exact: true,
      columns: (records = [], metaData) => {
  
        console.log(records, "record from api")
        
        const codeValueMetaData = metaData && metaData.codeOptions
        
     console.log(codeValueMetaData, "codeValueMetaData")
    
 
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "2",
          value: 'sno',
          label: 'S.No',
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) => row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : rowIndex + 1,
          type: 'text'
        },
  
       
      ]},
    },
    {
      schemaId: "b3BlcmF0aW9uRm9sbG93dXBDb21w",
      name: 'operationFollowupCompletedList',
      title: 'Operations Followup Completed List',
      formTitle: 'Operations Followup Completed List',
      path: '/operation-followup-completed-list',
      visible: true,
      ...b3BlcmF0aW9uRm9sbG93dXBDb21w,
      page: 'OperationFollowupCompletedList',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    //followup update
    {
      schemaId: "Zm9sbG93dXBVcGxvYWQ",
      name: 'followupUpdate',
      title: 'Followup Update',
      formTitle: 'Followup Update',
      path: '/followup-upload',
      visible: true,
      ...Zm9sbG93dXBVcGxvYWQ,
      page: 'FollowupUpdate',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
     //followup update
     {
      schemaId: "c2FsZXNQeXJhbWlkUm",
      name: 'salesPyramidReports',
      title: 'Sales Pyramid Reports',
      formTitle:'Sales Pyramid Reports',
      path: '/sales-pyramid-reports',
      visible: true,
      ...c2FsZXNQeXJhbWlkUm,
      page: 'SalesPyramidReports',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    //employee instant request
    {
      schemaId: "ZW1wbG95ZWVJbnN0",
      name: 'employeeInstantRequest',
      title: 'Employee Instant Request',
      formTitle:'Employee Instant Request',
      path: '/employee-instant-request',
      visible: true,
      ...ZW1wbG95ZWVJbnN0,
      page: 'EmployeeInstantRequest',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    // operation followup reason
    {
      schemaId: "ZGVsaXZlcmFibGVfZ",
      name: 'deliverable_followup_reason',
      title: 'Operation Followup Reason',
      formTitle: 'Operation Followup Reason',
      path: '/operation-followup-reason',
      visible: true,
      ...ZGVsaXZlcmFibGVfZ,
      page: 'OperationFollowupReason',
      exact: true,
      columns: (records = [], metaData) => {
  
        console.log(records, "record from api")
        
        const codeValueMetaData = metaData && metaData.codeOptions
        
     console.log(codeValueMetaData, "codeValueMetaData")
      
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "2",
          value: 'sno',
          label: 'S.No',
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) => row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : rowIndex + 1,
          type: 'text'
        },
        {
          id: "3",
           value: "actions",
           label: "Action",
           sort: false,
           editRecord: false,
           viewRecord: true,
           editFormatter: "actions",
           type: "text",
        },
  
        {
          id: "5",
          value: 'reasonName',
          label: 'Reason Name',
          placeholder: 'Enter Reason Name',
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: 'text',
       //   required:true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.reasonName} </span>
            },
        },
        {
          id: "5",
          value: 'shortName',
          label: 'Short Name',
          placeholder: 'Enter Short Name',
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: 'text',
          required:true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.shortName} </span>
            },
        },
        {
          id: "8",
          value: "status",
           label: "Status",
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row) =>
             row.loading ? (
               <p className="card-text placeholder-glow">
                 <span className="placeholder col-7"></span>
               </p>
             ) : (
               <Badge
                 className={`font-size-12 badge rounded-pill ${row.status === 1
                   ? "bg-success badge-soft-success"
                   : "bg-danger badge-soft-danger"
                   }`}
                 color={row.badgeclass}
                 pill
               >
                 {row.status === 1 ? "Active" : "Inactive"}
               </Badge>
             ),
           type: "text",
        },
        {
          id: "9",
          value: 'insertedBy',
          label: 'Inserted By',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "10",
          value: 'updatedBy',
          label: 'Updated By',
          sort: false,
          editRecord: false,
          viewRecord: false    ,
          type: 'text'
        },
        {
          id: "11",
          value: 'createdAt',
          label: 'Created Date',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "12",
          value: 'updatedAt',
          label: 'Updated Date',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        }
      ]},
    },
    {
      schemaId: "cHJvZHVjdERldGFpb",
      name: 'productDetailReport',
      title: 'Product Detail Report',
      formTitle:'Product Detail Report',
      path: '/product-details-report',
      visible: true,
      ...cHJvZHVjdERldGFpb,
      page: 'ProductDetailReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      ]},
    },
    {
      schemaId: "Zm9sbG93dX",
      name: 'followupReport',
      title: 'Followup Report',
      formTitle:'Followup Report',
      path: '/followup-report',
      visible: true,
      ...Zm9sbG93dX,
      page: 'FollowupReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },

    {
      schemaId: "bGVhZEF2ZXJhZ2VS",
      name: 'leadAverageReport',
      title: 'LeadAverageReport',
      formTitle:'LeadAverageReport',
      path: '/lead-average-report',
      visible: true,
      ...bGVhZEF2ZXJhZ2VS,
      page: 'LeadAverageReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    {
      schemaId: "bWlzc2VkRm9sbG93d",
      name: 'missedFollowupReport',
      title: 'MissedFollowupReport',
      formTitle:'MissedFollowupReport',
      path: '/missed-followup-report',
      visible: true,
      ...bWlzc2VkRm9sbG93d,
      page: 'MissedFollowupReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    //ProductDetailsStatusReport
    {
      schemaId: "cHJvZHVjdERldGF",
      name: 'productDetailStatusReport',
      title: 'ProductDetailStatusReport',
      formTitle:'ProductDetailStatusReport',
      path: '/missed-followup-report',
      visible: true,
      ...cHJvZHVjdERldGF,
      page: 'ProductDetailStatusReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    {
      schemaId: "ZmxyUGVuZGluZ0",
      name: 'flrPendingDataReport',
      title: 'FlrPendingDataReport',
      formTitle:'FlrPendingDataReport',
      path: '/flr-pending-data-report',
      visible: true,
      ...ZmxyUGVuZGluZ0,
      page: 'FlrPendingDataReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    {
      schemaId: "Y3JtV2lzZUZvbGxvd3",
      name: 'crmWiseFollowupTypeReport',
      title: 'CrmWiseFollowupTypeReport',
      formTitle:'CrmWiseFollowupTypeReport',
      path: '/crm-wise-follow-up-type-report',
      visible: true,
      ...Y3JtV2lzZUZvbGxvd3,
      page: 'CrmWiseFollowupTypeReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    {
      schemaId: "b3RoZXJCcmFuY2hEY",
      name: 'otherBranchDataPendingReport',
      title: 'OtherBranchDataPendingReport',
      formTitle:'OtherBranchDataPendingReport',
      path: '/other-branch-data-pending-report',
      visible: true,
      ...b3RoZXJCcmFuY2hEY,
      page: 'OtherBranchDataPendingReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    {
      schemaId: "ZXZlbnRXaXNlRGF0",
      name: 'eventWiseDataCopy',
      title: 'EventWiseDataCopy',
      formTitle:'EventWiseDataCopy',
      path: '/event-wise-data-copy',
      visible: true,
      ...ZXZlbnRXaXNlRGF0,
      page: 'EventWiseDataCopy',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    {
      schemaId: "Y3JtV2lzZVByb2R1Y3RT",
      name: 'crmWiseProductStatusAgingReport',
      title: 'CrmWiseProductStatusAgingReport',
      formTitle:'CrmWiseProductStatusAgingReport',
      path: '/crm-product-product-status-aging',
      visible: true,
      ...Y3JtV2lzZVByb2R1Y3RT,
      page: 'CrmWiseProductStatusAgingReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    {
      schemaId: "ZGF0YUNvcHlEZWxldGVk",
      name: 'dataCopyDeleted',
      title: 'DataCopyDeleted',
      formTitle:'DataCopyDeleted',
      path: '/data-copy-deleted',
      visible: true,
      ...ZGF0YUNvcHlEZWxldGVk,
      page: 'DataCopyDeleted',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
    {
      schemaId: "ZXdRdWV1ZVBsYW5uaW5nUmVwb3J0",
      name: 'ewQueuePlanningReport',
      title: 'ewQueuePlanningReport',
      formTitle:'ewQueuePlanningReport',
      path: '/ew-queue-planning-report',
      visible: true,
      ...ZXdRdWV1ZVBsYW5uaW5nUmVwb3J0,
      page: 'EwQueuePlanningReport',
      exact: true,
      columns: () => {
  
       return[
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
      
  
       
      ]},
    },
]

export default schemaNew
